<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';

import { required, email } from '@core/utils/validations/validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopicid: '',
        tipopicdescricao: '',
        tipopicinformavalorbrutoliquido: '',
        tipopictipocontrole: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiitem: null,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.fetchDataFromitem();
  },
  methods: {
    async fecharModal() {
      this.$emit('cancel');
      this.$bvModal.hide(this.idModal);
      this.$bvModal.hide('modal-att-pic');
    },
    async validateForm() {
      const user = localStorage.getItem('userData');
      const userData = JSON.parse(user);
      this.dataForm.usuarioidaprovador = userData.userData.id;
      this.dataForm.picsituacao = 'Reprovada';
      console.log(this.dataForm);
      this.$emit('salvar', this.dataForm);
      this.$bvModal.hide(this.idModal);
      dataForm.picobservacaoaprovador = '';
    },
    toUpperCase() {
      this.dataForm.tipopicid = this.dataForm.tipopicid.toUpperCase();
    },
    async fetchDataFromitem() {
      try {
        const response = await axios.get(`/tabela-preco-item/findAllById/?tabelapreco_id=${this.tabprecoid}`);
        this.dataFromApiitem = response.data.data.map((item) => ({ value: item.item.item_id, text: item.item.item_descricao }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.tipopicdescricao === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Motivo da Reprovação"
                label-for="picobservacaoaprovador"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-textarea
                    v-model="dataForm.picobservacaoaprovador"
                    id="picobservacaoaprovador"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a observacao"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

  </b-modal>
</template>
